/* @flow */
import * as React from 'react';
import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import BoxHeader from 'components/BoxHeader';
import PhoneCallNoteForm from 'phoneCalls/components/PhoneCallNoteForm';

type Props = {
  // the phone call uuid
  uuid: string,
  // callback added by the modal trigger
  onRequestHide?: Function,
};

function PhoneCallNoteModal(props: Props) {
  return (
    <Dialog {...props} size="medium">
      <BoxHeader
        textAlign="left"
        title="Call notes"
        subtext="Add call details or follow-ups here. Only you can see the notes you add to a call."
      />
      <BoxBody>
        <PhoneCallNoteForm uuid={props.uuid} onSave={props.onRequestHide} />
      </BoxBody>
    </Dialog>
  );
}

export default PhoneCallNoteModal;
